module.exports = __webpack_public_path__ + "img/section2-img1.f5565b1a.png";